<div [class.is-filtered]="isFiltered">
  <mat-form-field>
    <mat-label>Filter</mat-label>
    <mat-date-range-input (click)="rangePicker.open()" [formGroup]="form" [rangePicker]="rangePicker">
      <input formControlName="start" matStartDate placeholder="Van" readonly>
      <input formControlName="end" matEndDate placeholder="Tot" readonly>
    </mat-date-range-input>
    <mat-date-range-picker #rangePicker [calendarHeaderComponent]="matCalendarHeaderComponent"></mat-date-range-picker>
  </mat-form-field>
  <button (click)="clearFilterButton()" [class.show]="isFiltered" mat-icon-button type="button">
    <mat-icon>clear</mat-icon>
  </button>
</div>
